import { UserDtoSchema } from "@/modules/profile/userProfile/userDto"
import { ProgramType, ProgramVisibility } from "@/modules/programs/types/programTypes"
import { BlockSessionInputDtoSchema, SessionBlockDtoSchema } from "@/modules/sessions/gateway/sessionBlockDto"
import { SocialPostResumeLightDtoSchema } from "@/modules/social/gateway/socialDto"
import { z } from "zod"

/* DTO object returned by :
 * GET  /web/programs/on-off/{programId}/sessions/sessionsByDate/{sessionId}
 * GET  /web/programs/on-off/{programId}/sessions/sessionsByIndex/{sessionId}
 * GET  /web/programs/on-off/{programId}/sessionsByDate as array
 * GET  /web/programs/on-off/{programId}/sessionsByIndex as array
 * POST /web/programs/on-off/{programId}/sessions
 * PUT  /web/programs/on-off/{programId}/sessions/{sessionId}
 */
export const OnOffSessionDetailsDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    date: z.string().nullable(),
    owner: UserDtoSchema,
    programId: z.string(),
    programName: z.string(),
    programVisibility: z.enum(ProgramVisibility),
    hideSessionContent: z.boolean().nullable(),
    weightliftingTag: z.boolean(),
    gymnasticTag: z.boolean(),
    cardioTag: z.boolean(),
    restDay: z.boolean(),
    index: z.number().nullable(),
    programType: z.enum(ProgramType),
    socialPostId: z.string().nullable(),
    socialResume: SocialPostResumeLightDtoSchema.nullable(),
    blocks: z.array(SessionBlockDtoSchema),
    sessionCompletedByUser: z.boolean(),
  })
  .meta({ id: "OnOffSessionDetailsDtoSchema" })

/* DTO object expected by :
 * POST /web/programs/on-off/{programId}/sessions
 * PUT  /web/programs/on-off/{programId}/sessions/{sessionId}
 */
export const OnOffSessionInputDtoSchema = z
  .object({
    name: z.string().min(0).max(64),
    description: z.string().min(0).max(65535).nullable(),
    duration: z.number(),
    blocks: z.array(BlockSessionInputDtoSchema),
    hideSessionContent: z.boolean().nullable(),
    weightliftingTag: z.boolean(),
    gymnasticTag: z.boolean(),
    cardioTag: z.boolean(),
    restDay: z.boolean(),
    index: z.number().nullable(),
  })
  .meta({ id: "OnOffSessionInputDtoSchema" })

export type OnOffSessionDetailsDto = z.infer<typeof OnOffSessionDetailsDtoSchema>
export type OnOffSessionInputDto = z.infer<typeof OnOffSessionInputDtoSchema>
